import { asyncActionType } from 'util/methods';

export const LOGIN_INIT = 'LOGIN_INIT';
export const LOGIN_BEGIN = 'LOGIN_BEGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const LoginTypes = {
  USER_UPDATE_PASSWORD: asyncActionType('USER_UPDATE_PASSWORD'),
  USER_SOCIAL_LOGIN: asyncActionType('USER_SOCIAL_LOGIN'),
  USER_GET_LINKEDIN_INFO: asyncActionType('USER_GET_LINKEDIN_INFO'),
};
